import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ProjetoCadastro } from 'src/app/modules/projeto-completo/models/projeto-cadastro.model';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { ProjetoAgregadorService } from 'src/app/modules/projeto-completo/services/projeto-agregador.service';

@Component({
  selector: 'app-agregador-cadastro-view',
  templateUrl: './agregador-cadastro-view.component.html',
  styleUrls: ['./agregador-cadastro-view.component.scss']
})
export class AgregadorCadastroViewComponent extends BaseListComponent<ProjetoCadastro> implements OnInit, OnDestroy {

  idProjeto: number;
  projeto: any;
  loadingCronograma: boolean;
  isLoadingBlock: boolean;
  pathRoute: string;
  menu: any[];

  constructor(
    private myService: ProjetoAgregadorService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private navigation: NavigationService,
  ) {
    super()
  }

  ngOnInit(): void {
    this.loading();
    this.idProjeto = this.activatedRoute.snapshot.parent.parent.params.idProjeto;
    if (!this.projeto || !this.projeto.permissions.edit_check) {
      this.msgError('Você não possui permissão para visualizar este projeto!');
      this.navigation.back([`projetos/agregador`]);
    }
    this.initMenu();
    this.loaded();
    console.log(this.projeto)
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initMenu(path = null) {
    this.pathRoute = path ? path : "/projetos/agregador/" + this.idProjeto + "/";

    this.menu = [
      {
        label: "Cadastro Projetos",
        rota: "cadastro",
        active: true,
      },
      {
        label: "Cadastro " + this.projeto?.menu?.tipo_cadastro,
        rota: "produto",
        active: this.projeto?.menu?.tipo_cadastro,
      },
      {
        label: "Entregas",
        rota: "entregas",
        active: true,
      },
      {
        label: "Indicadores",
        rota: "indicadores",
        active: true,
      },
      {
        label: "Execução Orçamentaria",
        rota: "execucao-orcamentaria",
        active: true,
      },
      {
        label: "Pontos Críticos",
        rota: "pontos-criticos",
        active: true,
      }
    ]
  }

  isActive(route: string): boolean {
    return this.router.routerState.snapshot.url.includes(route);
  }

  editar(){
   return [`/projetos/agregador/${this.idProjeto}/cadastro/editar`];
  }

  voltar() {
    this.navigation.back(['projetos', 'agregador']);
  }
}
